import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "wrapped-reasons-for-gip",
  templateUrl: "reasons-for-gip.html",
})
export class WrappedReasonsForGIPComponent implements OnInit {
  @Input() textArray: string;
  concatenatedText: string = "";
  showMore = false;

  ngOnInit(): void {
    this.concatenatedText = this.textArray;
  }

  constructor(public translatePipe: TranslateService) {}

  trimString(string, length) {
    return string.length > length
      ? string.substring(0, length) + "..."
      : string;
  }
}



// WEBPACK FOOTER //
// ./src/components/order-management/om-details/reasons-for-gip/reasons-for-gip.ts